import React, { useEffect, useState , useRef} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { Link, useParams } from "react-router-dom";
// import mapboxgl from "mapbox-gl";
// import "mapbox-gl/dist/mapbox-gl.css";
import { API_URL, formatDateAccordingTo } from "..";
import { Accordion, Button, Spinner } from "react-bootstrap";
import { Footprints } from "@phosphor-icons/react";
import swal from "sweetalert";
import TimeLineRouteForJob from "./TimeLineRouteForJob";
import FloatingChat from "./FloatingChat";
import { useMapbox } from "../GoogleMapsContext";

// // Set your Mapbox access token
// mapboxgl.accessToken = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";

const getStatusColor = (status) => {
  switch (status) {
    case "Waiting": return "#ff9900";
    case "Dispatched": return "#2850ab";
    case "Enroute": return "#90ee90";
    case "On Scene": return "#008000";
    case "Towing": return "#3294F5";
    case "Destination Arrival": return "#d700c9";
    case "Completed": return "#ccc";
    default: return "gray";
  }
};
const TrackingMap = ({ pickupAddress, dropoffAddress }) => {
  const {mapboxgl} = useMapbox();
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [route, setRoute] = useState(null);

  useEffect(() => {
    if (!map.current && mapContainer.current) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-98.5795, 39.8283], // Default center (USA)
        zoom: 3
      });
      map.current.addControl(new mapboxgl.NavigationControl());
    }

    return () => {
      if (map.current) {
        map.current.remove();
      }
    };
  }, []);

  useEffect(() => {
    if (!pickupAddress || !dropoffAddress || !map.current) return;

    const fetchRoute = async () => {
      try {
        // Get coordinates for pickup and dropoff
        const pickup = {lat: parseFloat(pickupAddress.lat),lng: parseFloat(pickupAddress.lng)}
        const dropoff = {lat:parseFloat(dropoffAddress.lat),lng: parseFloat(dropoffAddress.lng)}
        if (!pickup || !dropoff) return;

        // Remove existing route if any
        if (map.current.getLayer('route')) {
          map.current.removeLayer('route');
          map.current.removeSource('route');
        }

        // Add markers
        new mapboxgl.Marker({ color: '#4CAF50' }) // Green for pickup
          .setLngLat([pickup.lng, pickup.lat])
          .addTo(map.current);
        
        new mapboxgl.Marker({ color: '#F44336' }) // Red for dropoff
          .setLngLat([dropoff.lng, dropoff.lat])
          .addTo(map.current);

        // Fit bounds to show both points
        const bounds = new mapboxgl.LngLatBounds()
          .extend([pickup.lng, pickup.lat])
          .extend([dropoff.lng, dropoff.lat]);
        
        map.current.fitBounds(bounds, { padding: 50 });

        // Get directions
        const response = await fetch(
          `https://api.mapbox.com/directions/v5/mapbox/driving/${pickup.lng},${pickup.lat};${dropoff.lng},${dropoff.lat}?geometries=geojson&access_token=${mapboxgl.accessToken}`
        );
        const data = await response.json();
        
        if (data.routes && data.routes.length > 0) {
          const routeData = data.routes[0].geometry;
          
          // Add route layer
          map.current.addLayer({
            id: 'route',
            type: 'line',
            source: {
              type: 'geojson',
              data: {
                type: 'Feature',
                properties: {},
                geometry: routeData
              }
            },
            layout: {
              'line-join': 'round',
              'line-cap': 'round'
            },
            paint: {
              'line-color': '#FF0000',
              'line-width': 4
            }
          });
          
          setRoute(routeData);
        }
      } catch (error) {
        console.error("Error fetching route:", error);
      }
    };

    fetchRoute();
  }, [pickupAddress, dropoffAddress]);

  return (
    <div 
      ref={mapContainer} 
      style={{ 
        height: '100%', 
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden'
      }} 
    />
  );
};

const ViewJob = () => {
  const {id} = useParams();
  
  const [customercood, setCustomerCood] = useState({
    lat: '',
    lng: '',
  });
  const [isLoading , setIsLoading] = useState(false)
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [trackingData, setTrackingData] = useState([]);
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:''
  });
  const [statusList,setStatusList] = useState([])
  const [pickupCoords, setPickUpCoords] = useState({})
  const [dropoffCoords, setDropoffCoords] = useState({})
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedOptionService, setSelectedOptionService] = useState([]);
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  const handleChangeService = (selected) => {
    setSelectedOptionService(selected || []);
  };
  const [formData,setFormData] = useState({
    id: '',
    fullname: '',
    email: '',
    phone:'',
    address: '' ,
    zipcode: '',
    assigned_to: '',
    service_request: [],
    status: '',
    description: '',
    assigned_by: '',
    affiliate:{},
    job_cost:'',
    status:'',
  })
  const [selectDriver, setSelectDriver]= useState([])
  const [selectDriverSelect, setSelectDriverSelect]= useState({})
  const [jobsData , setJobData] = useState([])
  
  const fetchSingle = async ()=>{
    setIsLoading(true)
    const user = JSON.parse(localStorage.getItem('user'));
    if(user?.role ==='admin' ){
      let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
      }
      let response = await fetch(`${API_URL}/api/jobs/${id}`, { 
        method: "PUT",
        headers: headersList
      });
      
      let data = await response.json();
      
      if(data?.affiliate){
        setSelectedOptions({label : data.affiliate.business_name, value : data.assigned_to})
      }
      
      if(data.service_request){
        const convert = data.service_request.split(',')
        const convertArray = convert.map((item) => {
          return {label: item, value: item}
        })
        
        const statusLists = [
          { id: 1, label: 'Waiting', icon: 'mdi:clock', time: data.createdAt },
          { id: 2, label: 'Dispatched', icon: 'mdi:truck-delivery', time: data.dipatched_time },
          { id: 3, label: 'Enroute', icon: 'mdi:map-marker-path', time: data.enroute_time },
          { id: 4, label: 'On Scene', icon: 'mdi:map-marker-check', time: data.onscene_time },
          { id: 5, label: 'Towing', icon: 'mdi:tow-truck', time: data.towing_time },
          { id: 6, label: 'Destination Arrival', icon: 'mdi:flag-checkered', time: data.destination_time },
          { id: 7, label: 'Completed', icon: 'mdi:check-circle', time :data.completed_time },
        ];
        setStatusList(statusLists)
        setSelectedOptionService(convertArray)
      }
      const convert =  data?.address_marker.split(',')
      const drop =  data?.dropoff_address_marker.split(',')
      setPickUpCoords({
        lat: convert[0],
        lng: convert[1],
      })
      setDropoffCoords({
        lat: drop[0],
        lng: drop[1],
      })
      setCustomerCood({
        lat: convert[0],
        lng: convert[1],
      });
      setIsLoading(false)
      setFormData(data)
    } else {
      let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
      }
      let response = await fetch(`${API_URL}/api/job/affiliate/fetch-single/${id}`, { 
        method: "GET",
        headers: headersList
      });
      let data = await response.json();
      console.log(data)
      
      if(data.data.affiliate){
        setSelectedOptions({label : data.data.affiliate.business_name, value : data.data.assigned_to})
      }
      if(data.data.service_request){
        const convert = data.data.service_request.split(',')
        const convertArray = convert.map((item) => {
          return {label: item, value: item}
        })
        setSelectedOptionService(convertArray)
      }
      const statusLists = [
        { id: 1, label: 'Waiting', icon: 'mdi:clock', time:  data.data.createdAt },
        { id: 2, label: 'Dispatched', icon: 'mdi:truck-delivery', time:  data.data.dipatched_time },
        { id: 3, label: 'Enroute', icon: 'mdi:map-marker-path', time:  data.data.enroute_time },
        { id: 4, label: 'On Scene', icon: 'mdi:map-marker-check', time:  data.data.onscene_time },
        { id: 5, label: 'Towing', icon: 'mdi:tow-truck', time:  data.data.towing_time },
        { id: 6, label: 'Destination Arrival', icon: 'mdi:flag-checkered', time:  data.data.destination_time },
        { id: 7, label: 'Completed', icon: 'mdi:check-circle', time: data.data.completed_time },
      ];
      setStatusList(statusLists)
      if(data.data.driver_id){
        setSelectDriverSelect({value:data.data.driver.id, label:data.data.driver.name})
      }
      const convert =  data?.data?.address_marker.split(',')
      const drop =  data?.data?.dropoff_address_marker.split(',')
      setPickUpCoords({
        lat: convert[0],
        lng: convert[1],
      })
      setDropoffCoords({
        lat: drop[0],
        lng: drop[1],
      })
      setCustomerCood({
        lat: convert[0],
        lng: convert[1],
      });
      setFormData(data.data)
    }
    setIsLoading(false)
  }

  // const fetchJobsTracking = async () => {
  //   let headersList = {
  //     "Accept": "*/*",
  //     "Content-Type": "application/json"
  //   }
  //   try {
  //     let response = await fetch(API_URL+`/api/notification/job/${id}`, { 
  //       method: "GET",
  //       headers: headersList
  //     });
  //     let data = await response.json();
  //     if(data.message === 'Job data fetched successfully' || response.status ===200){
  //       setTrackingData(data.data)
  //     }else if(response.status ===404){
  //       setTrackingData([])
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     setTrackingData([])
  //   }
  // }

  React.useEffect(() => {
    fetchSingle();
    // fetchJobsTracking()
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };



  const [currentUser,setCurrentUser] = useState({})
  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if(user == null){
      window.location.href = '/sign-in'
    } else {
      setCurrentUser(user)
    }
  }
  
  useEffect(() => {
    getCurrentUser();
  }, []);

  const OnPressDelete = async () => {
    swal({
      title: "Are you sure you want to delete this job?",
      text: "This action cannot be undone!",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
        }
        let response = await fetch(`${API_URL}/api/job/affiliate/delete-single/${id}`, { 
          method: "DELETE",
          headers: headersList
        });
        let data = await response.json();
        if(data.message == "success"){
          window.history.back()
        }
      }
    });
  }
  
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="View Job" />
        {isLoading && (
    <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9000,
        borderRadius: '12px'
    }}>
        <Spinner
            animation="border" 
            role="status"
            variant="info"
            style={{ width: '3rem', height: '3rem' }}
        >
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
)}
        {formData.status && 
          <div className="navbar-header" style={{
            alignItems:"center",
            backgroundColor: formData.status === 'new' ? getStatusColor('Waiting') : getStatusColor(formData.status_for_job),
            color:'white', 
            display:'flex', 
            justifyContent:'space-between'
          }}>
            {
              currentUser?.role === 'admin'?
              <span>{formData?.status}</span>:
              <span>{formData?.status_for_job}</span>

            }
            <span>
              {formData.status === 'new' ?  
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Waiting').map(e=>e.time).toString()) :
                formData.status_for_job === 'Dispatched'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Dispatched').map(e=>e.time).toString()) : 
                formData.status_for_job === 'Enroute'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Enroute').map(e=>e.time).toString()):
                formData.status_for_job === 'Towing'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Towing').map(e=>e.time).toString()):
                formData.status_for_job === 'On Scene'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'On Scene').map(e=>e.time).toString()):
                formData.status_for_job === 'Destination Arrival'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Destination Arrival').map(e=>e.time).toString()):
                formData.status_for_job === 'Completed'? 
                formatDateAccordingTo(statusList.filter((e)=>e.label === 'Completed').map(e=>e.time).toString()):
                null
              }
            </span>
          </div>
        }
        
        <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
            <div className="row">
              <div className="col-md-12 text-end mb-3">
                {
                  formData?.tracking_status === true ?
                  <Link to={`/live-tracking/${id}`} className="btn btn-info">View Tracking Routes</Link>: null

                }
                &nbsp;&nbsp;
                <Link to={`/lead-edit/${id}`} className="btn btn-info">Edit Job</Link>
                &nbsp;&nbsp;
                <Button onClick={()=>OnPressDelete()} className="btn btn-danger">Move to trash</Button>
              </div>
            </div>
            <div className="row">
              <div className="col-xxl-5">
                <div className="p-4 rounded">
                  <Accordion defaultActiveKey="2">
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Location Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="p-2 rounded bg-white">
                          <p className="text-success fw-bold m-0">Pickup Location</p>
                          <p>{formData.address}</p>
                       
                        </div>
                        <div className="p-2 rounded bg-white">
                          <p className="text-danger fw-bold">Dropoff Location</p>
                          <p>{formData.dropoff_address}</p>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Customer Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <strong>Customer Name:</strong>
                            <p>{formData.fullname}</p>
                          </div>
                          <div className="col-md-6">
                            <strong>Contact No.:</strong>
                            <p>{formData.phone}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <strong>Email:</strong>
                            <p>{formData.email || "N/A"}</p>
                          </div>
                          <div className="col-md-6">
                            <strong>Status:</strong>
                            <p>{formData.status}</p>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Assignment Details</Accordion.Header>
                      <Accordion.Body>
                     {
                      currentUser?.role == 'owner'?
                      <div className="row">
                      <div className="col-md-6">
                        <strong>Assigned By:</strong>
                          <p>{selectedOptions.label}</p>
                      </div>
                      <div className="col-md-6">
                        <strong>Driver:</strong>
                        <p>{formData?.driver?.first_name + ' ' + formData?.driver?.last_name}</p>
                      </div>
                    </div>:
                       <div className="row">
                       <div className="col-md-6">
                         <strong>Assigned By:</strong>
                           <p>{formData?.users?.name}</p>
                       </div>
                       <div className="col-md-6">
                         <strong>Affiliate:</strong>
                         
                         <p>{formData?.affiliate?.business_name || 'N/a'}</p>
                       </div>
                     </div>
                     }
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                      <Accordion.Header>Job Details</Accordion.Header>
                      <Accordion.Body>
                        <strong>Cost:</strong>
                        <p>{formData.job_cost}</p>
                        <strong>Service Required:</strong>
                        <ul>
                          {selectedOptionService.map((e, index) => (
                            <li key={index}>{e.value}</li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                      <Accordion.Header>Vehicle Information</Accordion.Header>
                      <Accordion.Body>
                        <div className="row">
                          <div className="col-md-4">
                            <strong>License Plate:</strong>
                            <p>{formData?.license_plate}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>VIN:</strong>
                            <p>{formData?.vin}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>Type:</strong>
                            <p>{formData?.vehicle_type}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>Year:</strong>
                            <p>{formData?.vehicle_year}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>Make:</strong>
                            <p>{formData?.vehicle_make}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>Modal:</strong>
                            <p>{formData?.vehicle_model}</p>
                          </div>
                          <div className="col-md-4">
                            <strong>Vehicle Color:</strong>
                            <p>{formData?.vehicle_color}</p>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                      <Accordion.Header>Status Road Map</Accordion.Header>
                      <Accordion.Body>
                        <TimeLineRouteForJob 
                          statusList={statusList} 
                          status={formData.status === 'new' ? 'Waiting' : formData.status_for_job} 
                        />
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                      <Accordion.Header>Description</Accordion.Header>
                      <Accordion.Body>
                        <p>{formData.description}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>Attachment</Accordion.Header>
                      <Accordion.Body>
                        
                        {formData?.attachments?.lenght == 0 ? <p>No Attachement Found...</p> : null}
                        {formData?.attachments?.lenght == 0 ? null :
                        formData?.attachments?.map((e , index)=>(
                          <a key={index} href={e?.attachment_url} target="_blank">
                            <img  style={{width: 100, height: 100}}  src={e?.attachment_url}/>

                          </a>
                        ))  
                      }
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>

              <div className="col-xxl-7" style={{ height: '600px' }}>
                {customercood.lat && 
                pickupCoords?.lat !==undefined  && dropoffCoords?.lat !== undefined?
                  <TrackingMap 
                    pickupAddress={pickupCoords} 
                    dropoffAddress={dropoffCoords} 
                  /> :null
                }
              </div>
            </div>
          </div>
          {
            currentUser.role === 'owner'?
            <FloatingChat jobId={id}/>:null
          }
        </div>

        
      </MasterLayout>
    </>
  );
};

export default ViewJob;